import { action, computed, observable, makeObservable } from "mobx";

import { type KnownLocale } from "nvent-web/i18n";

import { UserStore } from "./User";

export class AppStore {
  isSideMenuVisible = false;

  get locale(): KnownLocale {
    return this.user.locale;
  }

  constructor(private user: UserStore) {
    this.user = user;

    makeObservable(this, {
      isSideMenuVisible: observable,
      locale: computed,
      toggleSideMenu: action.bound,
    });
  }

  toggleSideMenu(visible = !this.isSideMenuVisible) {
    this.isSideMenuVisible = visible;
  }

  showSideMenu = () => this.toggleSideMenu(true);
  hideSideMenu = () => this.toggleSideMenu(false);
}

export default AppStore;
